import SettingsTemplate from './SettingsTemplate';
export default SettingsTemplate;
